module.exports = __webpack_public_path__ + "img/NU.ab35047f.png";